import { Component, computed, inject, input, output } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { BaseComponent } from '../../base/base.component';
import { ModalService } from '../../../services';
import { ImportConfirmState } from '../../../models';
import { AlertComponent } from '../../alert/alert.component';
import { GridComponent } from '../../grids/grid/grid.component';

@Component({
  selector: 'app-import-preview-modal',
  templateUrl: './import-preview-modal.component.html',
  styleUrl: './import-preview-modal.component.scss',
  imports: [AlertComponent, GridComponent],
})
export class ImportPreviewModalComponent extends BaseComponent {
  protected readonly modalService = inject(ModalService);

  public readonly title = input('');
  public readonly columnDefs = input<ColDef[]>([]);
  public readonly rowData = input<any[]>([]);

  public readonly newCount = input(0);
  public readonly updateCount = input(0);
  public readonly invalidCount = input(0);
  public readonly warningCount = input(0);
  public readonly validCount = input(0);

  public readonly hasErrors = input(false);
  public readonly hasValidRows = input(false);

  /** The Confirm's progress and outcome - the base modal's `importState()`. */
  public readonly state = input<ImportConfirmState>({ status: 'ready' });

  public readonly confirm = output<void>();

  protected readonly importing = computed(() => this.state().status === 'importing');
  protected readonly outcomeUnknown = computed(() => this.state().status === 'unknown');
  protected readonly alertType = computed(() => (this.outcomeUnknown() ? 'warning' : 'danger'));

  confirmImport() {
    this.confirm.emit();
  }

  /**
   * After an unknown outcome the import may well have gone through, so Close counts as done: the
   * screen behind re-reads its list, as it does after a success.
   */
  close() {
    this.modalService.close(true);
  }
}
